// moms-harness:anchor v2
// Spec: docs/spec/auth/LOGISPRD-10053-okta-app-access-denied.yaml

import { lazyComponent } from '@/utils/lazyComponent'

export default lazyComponent(() => import('./index'))
